import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Slider from 'components/Slider';
import TagManagerService from 'services/TagManager';

let itemName = '';

const Items = ({arrTags, searchTerm}) => {

    const _getTags = () => {
        return arrTags?.map((elem, i) => {
            itemName = elem.label;
            return (
                <Link to={elem.url} key={i} className={"suggestions-tags-item "} onClick={_sendGtm}>
                    {elem.label}
                </Link>
            )
        })
    }
    const _sendGtm = () => {
        TagManagerService.interaction(searchTerm, itemName, "Click: Refinamiento de búsqueda")
    }

    return (
        <Slider arrows={true} className="suggestions-tags">
            <Link to={`/busqueda?ft=${searchTerm}`} className="suggestions-tags-item search-term">{searchTerm}</Link>

            {_getTags()}
        </Slider>
    )
}

Items.propTypes = {
    arrTags: PropTypes.array,
    searchTerm: PropTypes.string
}

export default Items;